module.exports = __webpack_public_path__ + "static/media/locationIcon.d951b2e5.svg";